import { ENV } from '../../config';

export const LEARNING_PATH_ROUTER = {
    list: `${ENV.apiUrl}/api/v1/learning-path`,
    show: `${ENV.apiUrl}/api/v1/learning-path/`,
};
